var render = function render(){var _vm=this,_c=_vm._self._c;return _c('forgotpass',{attrs:{"email-enabled":false,"is-dark":true,"register-route":"register","solo":true,"password-title":_vm.newPasswordTitle,"password-enabled":_vm.hasPin,"pin-enabled":_vm.hasPin,"is-loading":_vm.isLoading,"outlined":false,"icon-enabled":true,"backButtonEnabled":true},on:{"forgotpass":_vm.forgotpass}})
}
var staticRenderFns = []

export { render, staticRenderFns }